import moment from 'moment'
import 'moment/locale/es-mx'

const fetchDay = (value) => {
  return value ? moment(value).format('YYYY-MM-DD') : ''
}

const fetchTime = (value) => {
  return value ? moment(value).format('HH:mm') : ''
}

const displayDay = (value) => {
  return value ? moment(value).format('DD/MMMM/YYYY') : ''
}

const displayFullDate = (value) => {
  return value ? moment(value).format('DD/MMMM/YYYY h:mmA') : ''
}

const diffDate = (value) => {
  const diff = moment(value).diff(moment(), 'minutes')
  const numdays = Math.floor(Math.abs(diff) / 1440)
  const numhours = Math.floor((Math.abs(diff) % 1440) / 60)
  const numminutes = Math.floor((Math.abs(diff) % 1440) % 60)
  let daysText, hoursText, minText
  if (numdays === 0) {
    daysText = ''
  } else if (numdays === 1) {
    daysText = `${numdays} día`
  } else {
    daysText = `${numdays} días`
  }
  if (numhours === 0) {
    hoursText = ''
  } else if (numhours === 1) {
    hoursText = `${numhours} hr`
  } else {
    hoursText = `${numhours} hrs`
  }
  if (numminutes === 0) {
    minText = ''
  } else if (numminutes === 1) {
    minText = `${numminutes} min`
  } else {
    minText = `${numminutes} min`
  }
  return `${daysText} ${hoursText} ${minText}`
}
const diffMin = (value) => {
  return moment(value).diff(moment(), 'minutes')
}
const today = (format) => {
  return moment().format(format)
}
const nowDay = (format) => {
  return moment().format(format).split('T').shift()
}
const nowTime = (format) => {
  return moment().format(format).split('T').pop()
}

export { fetchDay, fetchTime, displayDay, displayFullDate, diffDate, diffMin, today, nowDay, nowTime }
